import React from "react";
import { useDispatch } from "react-redux";
import { DeleteForever, Edit } from "@material-ui/icons";
import Button from "components/CustomButtons/Button";
import { Modal } from "components/Modal/Modal";
import { useOpenComponent } from "hooks/useOpenComponent";
import { ColumnContainer } from "utils/columnsStyle";
import {
  deleteShipperTruck,
  shipperTruckSelected,
  editShipperTruckMode,
  deleteShipperTruckMode
} from "redux/actions/shipperTrucks/shipperTrucksAction";

const columns = [
  {
    Header: "N. Economico",
    accessor: "economicNumber",
    filterable: true,
    filterMethod: (filter, row) =>
      row.economicNumber
        ? row.economicNumber.toLowerCase().includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: "Permiso",
    accessor: "permissionShipperTruck",
    filterable: true,
    filterMethod: (filter, row) =>
      row.permissionShipperTruck
        ? row.permissionShipperTruck.toLowerCase().includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: "Tipo",
    accessor: "type",
    filterable: true,
    filterMethod: (filter, row) =>
      row.type
        ? row.type.toLowerCase().includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: "Capacidad",
    accessor: "capacity",
    filterable: true,
    filterMethod: (filter, row) =>
      String(row.capacity)
        ? String(row.capacity).includes(filter.value)
        : "",
  },
  {
    Header: "Licencia",
    accessor: "license",
    filterable: true,
    filterMethod: (filter, row) =>
      row.license
        ? row.license.toLowerCase().includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: "Placas",
    accessor: "plates",
    filterable: true,
    filterMethod: (filter, row) =>
      row.plates
        ? row.plates.toLowerCase().includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: "Modelo",
    accessor: "model",
    filterable: true,
    filterMethod: (filter, row) =>
      row.model
        ? row.model.toLowerCase().includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: "Permiso SCT",
    accessor: "permissionSCT",
    filterable: true,
    filterMethod: (filter, row) =>
      row.permissionSCT
        ? row.permissionSCT.toLowerCase().includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: "T.Servicio",
    accessor: "typeService",
    filterable: true,
    filterMethod: (filter, row) =>
      row.typeService
        ? row.typeService.toLowerCase().includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: "Compartimiento",
    accessor: "compartmen",
    filterable: true,
    filterMethod: (filter, row) =>
      String(row.compartmen)
        ? String(row.compartmen).includes(filter.value)
        : "",
  },
  {
    Header: "Acciones",
    filterable: false,
    Cell: ({ original }) => {
      const dispatch = useDispatch();
      const { isOpen, handleIsOpen } = useOpenComponent();
      const openEditPG = () => {
        dispatch(editShipperTruckMode());
        original.modal();
        dispatch(shipperTruckSelected(original.id));
      };
      const openDeletePG = () => {
        dispatch(deleteShipperTruckMode());
        dispatch(deleteShipperTruck(original.id));
        handleIsOpen();
      };

      return (
        <>
          <Modal
            isOpen={isOpen}
            handleClose={handleIsOpen}
            textButton1="Eliminar"
            textButton2="Cancelar"
            actionFunction1={handleIsOpen}
            actionFunction2={openDeletePG}
            textContent="¿Estas seguro que se desea eliminar esta PG?"
          />
          <ColumnContainer>
            <Button color="info" simple round justIcon onClick={openEditPG}>
              <Edit />
            </Button>
            <Button style={{ fontSize: ".86rem", fontWeight: "bold" }} color="danger" round justIcon simple onClick={handleIsOpen}>
              <DeleteForever style={{ margin: 0 }} />
            </Button>
          </ColumnContainer>
        </>
      );
    }
  },
];

export { columns };
